/* Gerado por tools/lp-vip/portar.py a partir de E:/Sites/magon-landing-page/script.js. Edite lá e rode o script. */
(() => {
const LP = document.getElementById('lp-vip');
if (!LP) return;

/* ==========================================================================
   MAGON CONCEPTH — Landing page
   Configuração rápida: ajuste CONFIG abaixo.
   ========================================================================== */

const CONFIG = {
  // Link do convite do grupo. Enquanto estiver '#', os botões ficam inativos.
  // Ex.: 'https://chat.whatsapp.com/XXXXXXXXXXXXXXXX'
  whatsappUrl: 'https://chat.whatsapp.com/GhNtufFmEZI5F9oyKOlnlG',
};

/* --------------------------------------------------------------------------
   Botões do WhatsApp
   -------------------------------------------------------------------------- */
(function linksWhatsApp() {
  const botoes = LP.querySelectorAll('[data-whatsapp]');
  if (!botoes.length) return;

  const url = (CONFIG.whatsappUrl || '').trim();
  const valido = url && url !== '#';

  if (!valido) {
    console.warn('[MAGON] CONFIG.whatsappUrl ainda não foi preenchido em script.js.');
  }

  botoes.forEach((el) => {
    if (valido) {
      el.href = url;
      return;
    }
    // Sem link configurado: não leva a lugar nenhum, mas continua focável.
    el.setAttribute('aria-disabled', 'true');
    el.addEventListener('click', (ev) => ev.preventDefault());
  });
})();

/* --------------------------------------------------------------------------
   Vídeos em autoplay mudo (hero e colagem), com controle de pausa
   -------------------------------------------------------------------------- */
(function autoVideos() {
  const reduzido = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setup = (video) => {
    const wrap = video.closest('[data-video]') || video.parentElement;
    const toggle = wrap ? wrap.querySelector('.video-toggle') : null;
    const rotulo = toggle ? toggle.querySelector('.sr-only') : null;
    let pausadoPeloUsuario = false;

    const sync = () => {
      if (!toggle) return;
      const parado = video.paused;
      toggle.classList.toggle('is-paused', parado);
      if (rotulo) rotulo.textContent = parado ? 'Reproduzir vídeo' : 'Pausar vídeo';
    };

    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);

    if (toggle) {
      toggle.addEventListener('click', () => {
        pausadoPeloUsuario = !video.paused;
        if (video.paused) video.play().catch(sync);
        else video.pause();
      });
    }

    if (reduzido.matches) {
      // Quem pediu menos movimento no sistema vê um quadro parado, não o vídeo.
      video.autoplay = false;
      video.pause();
      const still = parseFloat(video.dataset.still);
      if (!Number.isNaN(still)) {
        const irPara = () => {
          try { video.currentTime = Math.min(still, (video.duration || still) - 0.1); } catch { /* ignora */ }
        };
        if (video.readyState >= 1) irPara();
        else video.addEventListener('loadedmetadata', irPara, { once: true });
      }
    } else {
      // Alguns navegadores bloqueiam o autoplay mesmo mudo.
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(sync);
    }

    // Economiza bateria e banda enquanto o vídeo está fora da tela.
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        ([entry]) => {
          if (reduzido.matches || pausadoPeloUsuario) return;
          if (entry.isIntersecting) video.play().catch(() => {});
          else if (!video.paused) video.pause();
        },
        { threshold: 0.1 }
      );
      io.observe(video);
    }

    sync();
  };

  LP.querySelectorAll('.js-video').forEach(setup);
})();

/* --------------------------------------------------------------------------
   Primeira dobra "virando a página": um gesto de scroll sai do hero e para
   exatamente no começo da segunda seção. Daí em diante o scroll é normal.
   -------------------------------------------------------------------------- */
(function viraPrimeiraDobra() {
  const hero = LP.querySelector('.hero');
  if (!hero) return;

  const desktop = window.matchMedia('(min-width: 901px)');
  const reduzido = window.matchMedia('(prefers-reduced-motion: reduce)');

  // No mobile o hero empilha (não ocupa a tela inteira) e sequestrar o toque
  // atrapalha mais do que ajuda. Com movimento reduzido, idem.
  const ligado = () => desktop.matches && !reduzido.matches;

  let animando = false;

  const animarAte = (destino, duracao = 780) => {
    const inicio = window.scrollY;
    const delta = destino - inicio;
    if (Math.abs(delta) < 2) return;

    animando = true;
    const raiz = document.documentElement;
    const antes = raiz.style.scrollBehavior;
    raiz.style.scrollBehavior = 'auto'; // senão o smooth global briga com o rAF

    const t0 = performance.now();
    const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

    const passo = (agora) => {
      const t = Math.min((agora - t0) / duracao, 1);
      window.scrollTo(0, inicio + delta * ease(t));
      if (t < 1) {
        requestAnimationFrame(passo);
        return;
      }
      raiz.style.scrollBehavior = antes;
      animando = false;
    };

    requestAnimationFrame(passo);
  };

  window.addEventListener(
    'wheel',
    (ev) => {
      if (!ligado() || ev.ctrlKey) return; // ctrl+scroll é zoom

      const fim = hero.offsetTop + hero.offsetHeight;

      // Se o hero for mais alto que a tela, parte dele ficaria sem ser visto.
      if (fim > window.innerHeight + 40) return;

      const y = window.scrollY;
      const descendoNoHero = ev.deltaY > 0 && y < fim - 2;
      const subindoLogoAbaixo = ev.deltaY < 0 && y > 0 && y <= fim + 2;

      // Fora da fronteira entre a 1ª e a 2ª seção, não mexe em nada.
      if (!descendoNoHero && !subindoLogoAbaixo) return;

      ev.preventDefault();
      if (animando) return; // engole a inércia do trackpad
      animarAte(descendoNoHero ? fim : 0);
    },
    { passive: false }
  );
})();

/* --------------------------------------------------------------------------
   Animações de entrada
   -------------------------------------------------------------------------- */
(function revealOnScroll() {
  const items = LP.querySelectorAll('.reveal');
  if (!items.length) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
  );

  items.forEach((el) => io.observe(el));
})();
})();
